var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7q7f3vvvia",
    d: "M0 0.899L23 0.899 23 23 0 23z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fz5vzezsvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7q7f3vvvia"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M22.667 17.645L17.985.898H.655l2.41 8.623 1.674 5.985c-.297-.073-.605-.117-.924-.117C1.708 15.389 0 17.093 0 19.195 0 21.296 1.708 23 3.815 23s3.815-1.704 3.815-3.805c0-.553-.12-1.076-.332-1.549L5.026 9.521h13.41l1.672 5.985c-.296-.073-.604-.117-.923-.117-2.107 0-3.815 1.704-3.815 3.806 0 2.101 1.708 3.805 3.815 3.805S23 21.296 23 19.195c0-.553-.12-1.076-.333-1.55",
    mask: "url(#fz5vzezsvb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M18.227 7.739L16.869 2.884 3.46 2.884 4.818 7.739z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.eb449d41f220f4b70adca97d4e33bcad.svg";
export { ForwardRef as ReactComponent };